export default __webpack_public_path__ + "static/media/vouchers_Mob_roi@2x.45c1ec7d.png";